/* Maverick Metals — PDP interactions: variant selection, live pricing,
   quantity stepper, image thumbs/tint, and spec tabs. */
(function () {
  var root = document.querySelector('[data-mm-product]');
  if (!root) return;

  var dataEl = root.querySelector('[data-mm-variants]');
  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

  var idInput = root.querySelector('[data-mm-variant-id]');
  var priceEl = root.querySelector('[data-mm-price]');
  var linePriceEl = root.querySelector('[data-mm-line-price]');
  var addBtn = root.querySelector('[data-mm-add]');
  var addLabel = root.querySelector('[data-mm-add-label]');
  var availEl = root.querySelector('[data-mm-availability]');
  var stockline = root.querySelector('[data-mm-stockline]');
  var colorNameEl = root.querySelector('[data-mm-selected-color]');
  var mainImg = root.querySelector('[data-mm-main-img]');
  var tintEl = root.querySelector('[data-mm-tint]');
  var qtyInput = root.querySelector('[data-mm-qty]');
  var bulkCta = root.querySelector('[data-mm-bulk-cta]');
  var bulkThreshold = parseInt(root.getAttribute('data-mm-bulk-threshold'), 10);
  // Account pricing (logged-in customers tagged off-D.DD or tier-N): the section
  // passes the customer's per-stick price in cents; it replaces the retail volume
  // tiers entirely — one flat price at any quantity. 0 = retail customer.
  var accountCents = parseInt(root.getAttribute('data-mm-account-cents'), 10);
  if (isNaN(accountCents) || accountCents <= 0) accountCents = 0;

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // Order by total feet (present only when the section renders data-mm-lengths).
  // Stick length comes from the Hole Spacing option: "8:6.75, 9:6.76, 10:6.77" keyed
  // by the option value's leading number; No holes / unlisted → the default length.
  // $/ft always divides by the SHORTEST length, so it's the same for every spacing.
  // Same format as snippets/mm-stick-length.liquid and mm-cart.js — keep in step.
  var feetIn = root.querySelector('[data-mm-feet]');
  var feetResult = root.querySelector('[data-mm-feet-result]');
  var feetFld = root.querySelector('[data-mm-fld-feet]');
  var sticksFld = root.querySelector('[data-mm-fld-sticks]');
  var priceFtEl = root.querySelector('[data-mm-price-ft]');
  var specLenEls = root.querySelectorAll('[data-mm-spec-len]');
  var specLenInitial = specLenEls.length ? specLenEls[0].textContent : '';
  var lenDefault = parseFloat(root.getAttribute('data-mm-len-default'));
  if (isNaN(lenDefault) || lenDefault <= 0) lenDefault = 6.75;
  var lenMap = {};
  var lenRef = lenDefault;
  (root.getAttribute('data-mm-lengths') || '').split(',').forEach(function (p) {
    var kv = p.split(':');
    var k = parseFloat(kv[0]), v = parseFloat(kv[1]);
    if (!isNaN(k) && v > 0) { lenMap[k] = v; if (v < lenRef) lenRef = v; }
  });
  var feetOn = !!(feetIn && root.hasAttribute('data-mm-lengths'));
  var anchor = 'feet'; // which box the customer typed in last: 'feet' or 'sticks'

  function fmtNum(x) {
    return (Math.round(x * 100) / 100).toLocaleString('en-US', { maximumFractionDigits: 2 });
  }
  function perFtCents(stickCents) { return Math.round(stickCents / lenRef); }

  function qty() {
    var n = parseInt(qtyInput && qtyInput.value, 10);
    return isNaN(n) || n < 1 ? 1 : n;
  }

  // Volume tiers from data-mm-tiers ("30:14, 100:12.50, ...") → [{q, cents}] asc.
  var tierNoteEl = root.querySelector('[data-mm-tier-note]');
  var tiers = (root.getAttribute('data-mm-tiers') || '').split(',').map(function (p) {
    var m = p.split(':');
    return { q: parseInt((m[0] || '').trim(), 10), cents: Math.round(parseFloat((m[1] || '').trim()) * 100) };
  }).filter(function (t) { return !isNaN(t.q) && !isNaN(t.cents); }).sort(function (a, b) { return a.q - b.q; });

  // Effective per-unit price (cents) for a given quantity, given the base price.
  // Account pricing wins outright — one flat per-stick price at any quantity
  // (exact for quoted off-D.DD prices; tier % prices are rounded per unit while
  // checkout rounds the line total, so those can differ by a cent — checkout is
  // authoritative). Retail: a tier may only lower the price — a stale or mistyped
  // tier above the current effective price is ignored, so more quantity never
  // raises the price.
  function unitCents(baseCents, q) {
    if (accountCents > 0) return accountCents;
    var eff = baseCents;
    for (var i = 0; i < tiers.length; i++) { if (q >= tiers[i].q && tiers[i].cents <= eff) eff = tiers[i].cents; }
    return eff;
  }

  function optionGroups() {
    return Array.prototype.slice
      .call(root.querySelectorAll('[data-mm-option]'))
      .sort(function (a, b) {
        return (+a.getAttribute('data-option-position')) - (+b.getAttribute('data-option-position'));
      });
  }

  function selectedValues() {
    return optionGroups().map(function (g) {
      var checked = g.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  }

  function findVariant(vals) {
    return variants.find(function (v) {
      return v.options.length === vals.length && v.options.every(function (o, i) { return o === vals[i]; });
    });
  }

  // Length (ft) of one stick for the chosen Hole Spacing; null until one is picked.
  function stickLength() {
    var group = optionGroups().filter(function (g) {
      return /spacing/i.test(g.getAttribute('data-option-name') || '');
    })[0];
    if (!group) return lenDefault;
    var checked = group.querySelector('input:checked');
    if (!checked) return null;
    var n = parseFloat(checked.value);
    return (!isNaN(n) && lenMap[n]) || lenDefault;
  }

  function readFeet() {
    var v = parseFloat(feetIn && feetIn.value);
    return isNaN(v) || v <= 0 ? null : v;
  }

  // Ordering by feet = full sticks + ONE stick cut to the nearest inch (client practice,
  // 2026-09-23). The cut stick is priced as a full stick, so quantity = full + 1.
  // No cut when the leftover rounds to 0" or to a full stick, and none below the
  // minimum-cut setting (that leftover ships as a full stick). Integer hundredths
  // keep e.g. 1440" / 81" from floating to 17.9999.
  var minCut = parseFloat(root.getAttribute('data-mm-min-cut'));
  if (isNaN(minCut) || minCut < 0) minCut = 0;
  var propLength = root.querySelector('[data-mm-prop-length]');
  var propCut = root.querySelector('[data-mm-prop-cut]');
  var propRun = root.querySelector('[data-mm-prop-run]');

  function cutPlan(feet, L) {
    var stickIn = L * 12;
    var wantIn = feet * 12;
    var full = Math.floor(Math.round(wantIn * 100) / Math.round(stickIn * 100));
    var cutIn = Math.round(wantIn - full * stickIn);
    if (cutIn <= 0) return { kind: 'exact', full: full, cutIn: 0, sticks: Math.max(1, full) };
    if (cutIn >= Math.round(stickIn)) return { kind: 'exact', full: full + 1, cutIn: 0, sticks: full + 1 };
    if (minCut > 0 && cutIn < minCut) return { kind: 'short', full: full, cutIn: cutIn, sticks: full + 1 };
    return { kind: 'cut', full: full, cutIn: cutIn, sticks: full + 1 };
  }

  // Line-item properties ride along only when there's a cut (disabled = not submitted).
  function setCutProps(plan, feet) {
    var on = !!(plan && plan.kind === 'cut');
    [propLength, propCut, propRun].forEach(function (el) { if (el) el.disabled = !on; });
    if (!on) return;
    if (propLength) {
      propLength.value = fmtNum(feet) + ' ft (' +
        (plan.full ? plan.full + (plan.full === 1 ? ' full stick' : ' full sticks') + ' + ' : '') +
        '1 cut to ' + plan.cutIn + ' in)';
    }
    if (propCut) propCut.value = String(plan.cutIn);
  }

  // Feet → sticks (with the cut plan), or sticks → feet, depending on which box was
  // typed in last. Runs before pricing so the qty is current.
  function syncFeet() {
    if (!feetOn) return;
    var L = stickLength();
    var feet = readFeet();
    var plan = anchor === 'feet' && feet && L ? cutPlan(feet, L) : null;
    if (plan) qtyInput.value = plan.sticks;
    setCutProps(plan, feet);
    var q = qty();
    if (anchor === 'sticks' && L) feetIn.value = String(Math.round(q * L * 100) / 100);
    if (feetFld) feetFld.classList.toggle('is-anchor', anchor === 'feet');
    if (sticksFld) sticksFld.classList.toggle('is-anchor', anchor === 'sticks');

    specLenEls.forEach(function (el) {
      el.textContent = L ? fmtNum(L) + ' ft · ' + fmtNum(L * 12) + ' in' : specLenInitial;
    });

    if (!feetResult) return;
    var sticks = q + (q === 1 ? ' stick' : ' sticks');
    feetResult.classList.remove('is-hint');
    if (!L) {
      feetResult.classList.add('is-hint');
      feetResult.textContent = feet
        ? 'Select a hole spacing to turn ' + fmtNum(feet) + ' ft into sticks. Stick length depends on spacing.'
        : 'Select a hole spacing, then enter the total feet you need.';
    } else if (plan && plan.kind === 'cut') {
      feetResult.innerHTML = fmtNum(feet) + ' ft → <strong>' + sticks + '</strong>: ' +
        (plan.full ? plan.full + ' full + ' : '') + '1 cut to ' + plan.cutIn + ' in ' +
        '<span class="mm-howmuch__over">(cut to the nearest inch; the cut stick is priced as a full stick)</span>';
    } else if (plan && plan.kind === 'short') {
      feetResult.innerHTML = fmtNum(feet) + ' ft → <strong>' + sticks + '</strong>, all full ' +
        '<span class="mm-howmuch__over">(the ' + plan.cutIn + ' in leftover is under our ' + fmtNum(minCut) +
        ' in minimum cut, so you get ' + fmtNum(q * L) + ' ft)</span>';
    } else if (plan) {
      feetResult.innerHTML = fmtNum(feet) + ' ft → <strong>' + sticks + '</strong> <span class="mm-howmuch__over">(exact, no cut)</span>';
    } else if (anchor === 'feet') {
      feetResult.textContent = 'Enter the total feet you need, or set the stick count directly.';
    } else {
      feetResult.innerHTML = '<strong>' + sticks + '</strong> = ' + fmtNum(q * L) + ' ft of track';
    }
  }

  // "Add 18 sticks to Cart" once the variant is known to be buyable.
  var addReady = false;
  function setAddLabel() {
    if (!addLabel || !addReady) return;
    var q = qty();
    addLabel.textContent = feetOn ? 'Add ' + q + (q === 1 ? ' stick' : ' sticks') + ' to Cart' : 'Add to Cart';
  }

  function updateColorTint() {
    var colorGroup = colorNameEl ? colorNameEl.closest('[data-mm-option]') : null;
    if (!colorGroup) return;
    var checked = colorGroup.querySelector('input:checked');
    if (!checked) return;
    if (colorNameEl) colorNameEl.textContent = checked.value;
    var hex = checked.getAttribute('data-hex');
    if (hex) root.style.setProperty('--mm-selected-tint', hex);
  }

  // At bulk quantities (≥ max orderable + 1), swap Add to Cart for the quote/call CTA.
  function applyBulkState() {
    if (!bulkCta || isNaN(bulkThreshold) || bulkThreshold < 1) return;
    root.classList.toggle('is-bulk', qty() >= bulkThreshold);
  }

  // Update the per-stick price, line total, and volume note from the current qty.
  function applyPricing(variant) {
    if (!variant || typeof variant.price !== 'number') return;
    var q = qty();
    var base = variant.price;
    var eff = unitCents(base, q);
    if (priceEl) priceEl.textContent = money(eff);
    if (priceFtEl) priceFtEl.textContent = money(perFtCents(eff));
    if (linePriceEl) linePriceEl.textContent = money(eff * q);
    if (tierNoteEl) {
      if (accountCents > 0) {
        tierNoteEl.hidden = true;
      } else {
        var paying = "You're paying " + money(eff) + '/stick' + (feetOn ? ' (' + money(perFtCents(eff)) + '/ft)' : '');
        if (eff < base) {
          tierNoteEl.textContent = paying + ' — a discount of ' + money(base - eff) + '/stick';
        } else {
          tierNoteEl.textContent = paying;
        }
        tierNoteEl.hidden = false;
      }
    }
    setAddLabel();
  }

  function update() {
    var vals = selectedValues();
    var variant = findVariant(vals);
    var unpicked = vals.indexOf(null) !== -1;

    if (idInput) idInput.value = variant ? variant.id : '';
    addReady = false;
    syncFeet();
    applyPricing(variant);
    applyBulkState();
    updateColorTint();

    // Unselected state: one or more options have no choice yet — hold Add to
    // Cart without reporting the base variant as unavailable.
    if (unpicked) {
      var missing = optionGroups().filter(function (g) {
        return !g.querySelector('input:checked');
      }).map(function (g) {
        return g.getAttribute('data-option-name') || 'Options';
      });
      if (addBtn) addBtn.disabled = true;
      if (addLabel) addLabel.textContent = missing.length === 1 ? 'Select ' + missing[0] : 'Select Options';
      return;
    }

    var available = !!(variant && variant.available);
    if (addBtn) addBtn.disabled = !available;
    if (addLabel) addLabel.textContent = available ? 'Add to Cart' : (variant ? 'Sold Out' : 'Unavailable');
    addReady = available;
    setAddLabel();
    if (availEl) {
      availEl.textContent = available ? 'IN STOCK' : (variant ? 'SOLD OUT' : 'UNAVAILABLE');
      availEl.classList.toggle('is-instock', available);
      availEl.classList.toggle('is-soldout', !available);
    }
    if (stockline) stockline.classList.toggle('is-out', !available);

    // Swap main image if the variant has its own photo.
    if (variant && variant.featured_image && mainImg && mainImg.tagName === 'IMG') {
      mainImg.src = variant.featured_image.src;
    }

    // Reflect in the URL for shareable links.
    if (variant && window.history && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }
  }

  // Option changes
  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-mm-option-input]')) update();
  });

  // Quantity stepper
  root.addEventListener('click', function (e) {
    var down = e.target.closest('[data-mm-qty-down]');
    var up = e.target.closest('[data-mm-qty-up]');
    if (!down && !up) return;
    var n = qty();
    n = up ? n + 1 : Math.max(1, n - 1);
    if (qtyInput) qtyInput.value = n;
    anchor = 'sticks';
    syncFeet();
    applyPricing(findVariant(selectedValues()));
    applyBulkState();
  });
  if (qtyInput) {
    qtyInput.addEventListener('input', function () {
      anchor = 'sticks';
      syncFeet();
      applyPricing(findVariant(selectedValues()));
      applyBulkState();
    });
  }
  if (feetOn) {
    feetIn.addEventListener('input', function () {
      anchor = 'feet';
      syncFeet();
      applyPricing(findVariant(selectedValues()));
      applyBulkState();
    });
    // Enter in the feet box shouldn't add to cart before the customer sees the stick count.
    feetIn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') e.preventDefault();
    });
    // Fresh _run per add so a second identical run becomes its own line (and its own
    // cut) instead of merging into one line with a single-run "Total length" label.
    // Form-level listener → runs before mm-cart.js's document-level submit handler.
    var buyForm = qtyInput && qtyInput.form;
    if (buyForm && propRun) {
      buyForm.addEventListener('submit', function () {
        propRun.value = Date.now().toString(36);
      });
    }
  }

  // Thumbnails
  root.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-mm-thumb]');
    if (!thumb || !mainImg || mainImg.tagName !== 'IMG') return;
    mainImg.src = thumb.getAttribute('data-mm-thumb');
  });

  // Spec tabs
  var tabs = root.querySelector('[data-mm-tabs]');
  if (tabs) {
    tabs.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-mm-tab]');
      if (!tab) return;
      var name = tab.getAttribute('data-mm-tab');
      tabs.querySelectorAll('[data-mm-tab]').forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      tabs.querySelectorAll('[data-mm-panel]').forEach(function (p) {
        var on = p.getAttribute('data-mm-panel') === name;
        p.classList.toggle('is-active', on);
        p.hidden = !on;
      });
    });
  }

  // Color dropdown: a button + popover over the same hidden radios, so variant
  // matching is untouched. Arrow keys move the radio selection and fire change per
  // step — those must NOT close the list; only row clicks, Escape, and outside
  // clicks close it. Without JS the list renders inline (no is-ready class).
  var dd = root.querySelector('[data-mm-dd]');
  if (dd) {
    var ddBtn = dd.querySelector('[data-mm-dd-btn]');
    var ddChip = dd.querySelector('[data-mm-dd-chip]');
    var ddName = dd.querySelector('[data-mm-dd-name]');
    var ddSetOpen = function (open) {
      dd.classList.toggle('is-open', open);
      if (ddBtn) ddBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var checked = dd.querySelector('input:checked');
        var row = checked && checked.nextElementSibling;
        if (row && row.scrollIntoView) row.scrollIntoView({ block: 'nearest' });
      }
    };
    var ddSync = function () {
      var checked = dd.querySelector('input:checked');
      if (!checked) return;
      if (ddName) ddName.textContent = checked.value;
      if (ddChip) {
        ddChip.style.background = checked.getAttribute('data-hex') || '';
        ddChip.classList.remove('is-empty');
      }
      if (ddBtn) ddBtn.classList.remove('is-empty');
    };
    dd.classList.add('is-ready');
    if (ddBtn) {
      ddBtn.addEventListener('click', function () {
        ddSetOpen(!dd.classList.contains('is-open'));
      });
      ddBtn.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        e.preventDefault();
        ddSetOpen(true);
        var checked = dd.querySelector('input:checked') || dd.querySelector('input');
        if (checked) checked.focus();
      });
    }
    dd.addEventListener('change', function (e) {
      if (e.target.matches('[data-mm-option-input]')) ddSync();
    });
    dd.addEventListener('click', function (e) {
      if (e.target.closest('.mm-dd__row')) {
        ddSetOpen(false);
        if (ddBtn) ddBtn.focus();
      }
    });
    document.addEventListener('click', function (e) {
      if (!dd.contains(e.target)) ddSetOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && dd.classList.contains('is-open')) {
        ddSetOpen(false);
        if (ddBtn) ddBtn.focus();
      }
    });
    ddSync();
  }

  // "Change length" from the cart lands here with ?mm_ft=120 — pre-fill the feet box.
  if (feetOn) {
    var ftParam = parseFloat(new URLSearchParams(window.location.search).get('mm_ft'));
    if (ftParam > 0) { feetIn.value = String(ftParam); anchor = 'feet'; }
  }

  // Initial sync
  update();
})();
